"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMsg = exports.qrLogin = exports.loginOut = exports.getLoginVersion = exports.getConfigStun = exports.getConfigPage = exports.getCaptchaImg = exports.getBusinessList = exports.getAccountInfo = exports.gameSendMsg = void 0;
var _request = _interopRequireWildcard(require("../utils/request"));
var _consts = require("../consts");
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*
 * @Author: liujunhong
 * @Date: 2022/10/11
 * @Desc:
 */

/**
 * 退出登录
 */
var loginOut = function loginOut(param) {
  return _request.default.post("".concat(_consts.API_URL, "/loginOut?isWeGame=").concat(param.isWeGame));
};
/**
 * 协议版本号
 */
exports.loginOut = loginOut;
var getLoginVersion = function getLoginVersion(param) {
  return _request.default.post("".concat(_consts.API_URL, "/login/version?isWeGame=").concat(param.isWeGame));
};
/**
 * 发送短信
 */
exports.getLoginVersion = getLoginVersion;
var sendMsg = function sendMsg(param) {
  return _request.default.post("".concat(_consts.API_URL, "/sms/sendSms"), {
    data: param
  });
};
/**
 * 发送短信
 */
exports.sendMsg = sendMsg;
var gameSendMsg = function gameSendMsg(param) {
  return _request.default.post("".concat(_consts.API_URL, "/sms/gameSendSms"), {
    data: _qs.default.stringify(param),
    headers: {
      'Content-Type': _request.CONTENT_TYPE.URLENCODED
    }
  });
};
/**
 * 获取bid
 */
exports.gameSendMsg = gameSendMsg;
var getBusinessList = function getBusinessList() {
  return _request.default.get("".concat(_consts.API_URL, "/sms/getBusiList"), {
    headers: {
      'Content-Type': _request.CONTENT_TYPE.URLENCODED
    }
  });
};
/**
 * 登录
 */
exports.getBusinessList = getBusinessList;
var qrLogin = function qrLogin(param) {
  return _request.default.post("".concat(_consts.API_URL, "/qrlogin?guildId=").concat(param.guild, "&isHaiWai=").concat(param.isHaiWai));
};
exports.qrLogin = qrLogin;
var getCaptchaImg = function getCaptchaImg(parameter) {
  return _request.default.get("".concat(parameter.url), {
    headers: {
      'Content-Type': _request.CONTENT_TYPE.URLENCODED
    }
  });
};
/**
 * 账号信息
 */
exports.getCaptchaImg = getCaptchaImg;
var getAccountInfo = function getAccountInfo() {
  return _request.default.get("".concat(_consts.HOST_URL, "/about/account/userAuthInfo"));
};
/**
 * 页面置灰开关
 */
exports.getAccountInfo = getAccountInfo;
var getConfigPage = function getConfigPage() {
  return _request.default.get("".concat(_consts.SQGameServer_URL, "/www/config/black"));
};
/**
 * 获取stun服务器地址
 * @param bid
 */
exports.getConfigPage = getConfigPage;
var getConfigStun = function getConfigStun(bid) {
  return _request.default.get("".concat(_consts.VALIDATION_2_URL, "/stun/url?bid=").concat(bid));
};
exports.getConfigStun = getConfigStun;